import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { installApiAuth } from "./utils/apiAuth.js";

installApiAuth();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
